

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';
import SelectIcon from "../../images/select-right-icon.svg";

var styles = {
  wrapper: function wrapper(props) {return {
      display: 'flex',
      font: {
        family: ['Lato', 'sans-serif']
      },
      width: props.width || '25rem'
    };},
  selectForChevronWrapper: {
    position: 'relative',
    '&::after': {
      content: '""',
      display: 'block',
      width: '2.4rem',
      height: '2.4rem',
      position: 'absolute',
      background: {
        image: "url(".concat(SelectIcon, ")"),
        repeat: 'no-repeat',
        size: 'cover'
      },
      bottom: '0.8rem',
      right: '0.6rem',
      pointerEvents: 'none'
    }
  },
  wrapperColumn: {
    flex: {
      direction: 'column'
    }
  },
  descriptionWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  description: {
    cursor: 'default',
    display: 'block',
    alignItems: 'flex-end',
    textOverflow: 'clip',
    overflowWrap: 'break-word',
    margin: { top: 0, bottom: '0.4rem' },
    color: colors.neutral[600],
    '&:focus': {
      outline: 'none'
    },
    letterSpacing: '0.02rem'
  },
  label: {
    color: colors.neutral[900],
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 500
    },
    letterSpacing: '0.02rem',
    marginBottom: '0.4rem'
  },
  select: function select(props) {return {
      width: '100%',
      borderRadius: '4px',
      boxSizing: 'border-box',
      // If there is explicitly set placeholder color - use it, if not - check the element's value, if it's the placeholder value -
      // apply grey text color, if not - apply black text color.
      color: props.placeholderColor ?
      props.placeholderColor :
      props.value === '' ?
      colors.neutral[500] :
      colors.neutral[900],
      font: {
        size: '1.6rem',
        lineHeight: '2.4rem'
      },
      letterSpacing: '0.02rem',
      padding: '0.9rem 1.5rem 0.9rem 0.8rem',
      textOverflow: 'ellipsis',

      '&:focus': {
        outline: 'none'
      },
      appearance: 'none'
    };},
  selectValidationTrue: {
    border: ['0.1rem', 'solid', colors.neutral[200]],

    '&:focus': {
      border: ['0.1rem', 'solid', colors.blue[500]],
      caretColor: colors.blue[500]
    }
  },
  selectValidationFalse: function selectValidationFalse(props) {return {
      border:
      props.value === '' ?
      ['0.1rem', 'solid', colors.blue[300]] :
      ['0.1rem', 'solid', colors.red[500]]
    };},
  selectDisabled: {
    cursor: 'not-allowed',
    backgroundColor: colors.neutral[100],
    opacity: '0.7'
  },
  selectGuideline: {
    maxWidth: '100%'
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map